
/**
 * @typedef {import('../../../api-v2/js-doc').V2MaintenanceMode} V2MaintenanceMode
 * @typedef {import('../../../api-v2/js-doc').V2MaintenanceModeUpdateRequest} V2MaintenanceModeUpdateRequest
 */
export class MaintenanceModeMapper {
  /**
   * @param {*} v1Response - v1 maintenance mode response
   * @returns {V2MaintenanceMode}
   */
  static v1MaintenanceToV2Maintenance (v1Response) {
    return {
      isEnabled: v1Response.maintenance_mode,
      message: v1Response.maintenance_message,
    }
  }

  /**
   * @param {*} v1RequestBody - Represents the V1 update request body
   * @returns {V2MaintenanceModeUpdateRequest}
   */
  static v1UpdateRequestToV2UpdateRequest (v1RequestBody) {
    return {
      isEnabled: v1RequestBody.maintenance_mode,
      message: v1RequestBody.maintenance_message,
      __v1Payload: {}, // Composed in v2
      __ingestThrough: true,
    }
  }
}

